import { render, staticRenderFns } from "./Uber2.vue?vue&type=template&id=f2fcf03c&scoped=true&"
import script from "./Uber2.vue?vue&type=script&lang=js&"
export * from "./Uber2.vue?vue&type=script&lang=js&"
import style0 from "./Uber2.vue?vue&type=style&index=0&id=f2fcf03c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fcf03c",
  null
  
)

export default component.exports